/* eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import Dashboard from "@/views/Dashboard.vue";

import users from "./module/users.js";
import category from "./module/category.js";
import attribute from "./module/attribute.js";
import locale from "./module/locale.js";
import vendor from "./module/vendor.js";

//Middleware
import isLogin from "../middleware/AuthMiddleware.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    meta:{
      navbar:false,
    },
    component: Login
  },
  users, category, vendor, attribute, locale,
  {
    path: "/dashboard",
    name: "dashboard",
    meta:{
      navbar:true,
      middleware:[
        isLogin,
      ]
    },
    component: Dashboard
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
